import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_NEWS } from '@/api/endpoints';
import { NEWS_QUERY_KEY } from '@/api/queryKeys';
import type { NewsItem } from '@/types/news';
import { unwrapAxiosResponse } from '@/utils/axios';

export const useNews = () =>
  useQuery<NewsItem[]>({
    queryKey: NEWS_QUERY_KEY,
    queryFn: () =>
      apiClient
        .get<NewsItem[]>(API_NEWS)
        .then(unwrapAxiosResponse)
        .then((news) => (Array.isArray(news) ? news : [])),
  });
